var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonEndPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26C15.7 14 5.5 3.66667 0.5 0H44L43.5 42C35.5 31.5 22 27 16.5 26Z",
    fill: "#F6821F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 42C25.9 34 15 32.6666 10.5 33H7V42H33.5Z",
    fill: "#F6821F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEndPattern);
export default __webpack_public_path__ + "static/media/buttonEndPattern.3aba701f352ad1695a56ddcec38d9b1b.svg";
export { ForwardRef as ReactComponent };